import styled, { css } from "styled-components"

import { color } from "../../../atoms/colors"

export const HeaderCell = styled.th`
  padding: 24px 8px 32px 8px;
  max-width: 240px;
  text-align: center;
  vertical-align: top;
  .header-cta {
    font-size: 16px;
    line-height: 24px;
  }
  &:first-child {
    text-align: left;
    padding-left: 24px;
  }
  &:last-child {
    padding-right: 24px;
  }
`

export const HeaderCellTitle = styled.h3`
  color: ${color.oxfordBlue[900]};
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  @media (max-width: 1200px) {
    font-weight: 900;
    font-size: 20px;
    line-height: 30px;
  }
`
export const HeaderCellSubtitle = styled.p`
  color: ${color.oxfordBlue[900]};
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
`

export const Cell = styled.td`
  vertical-align: ${(props) => (props.verticalAlignTop ? "top" : "center")};
  text-align: center;
  div {
    font-family: "Avenir";
    font-style: normal;
    text-align: center;
    color: ${color.copy[700]};
    a {
      text-decoration-line: underline;
      color: ${color.common.linkBlue};
      cursor: pointer;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    p {
      margin-bottom: 0px;
    }
  }
`

export const StarWrap = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;

  ${(props) =>
    props?.color &&
    css`
      svg {
        width: 16px;
        height: auto;
        path {
          stroke: ${props?.color};
          fill: ${props?.color};
        }
      }
    `}
  @media (max-width: 1200px) {
    margin-bottom: unset;
  }
`

export const IconWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
`

export const IconContent = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: ${(props) => (props?.centered ? "center" : "flex-start")};
  .gatsby-image-wrapper {
    width: 32px;
  }
`

export const IconText = styled.span`
  color: ${color.oxfordBlue[900]};
  font-weight: 900;
  text-align: left;
  font-size: 14px;
  @media (max-width: 1200px) {
    font-size: 16px;
  }
`

export const CellText = styled.span`
  display: block;
  width: 100%;
  color: ${color.oxfordBlue[900]};
  font-weight: 900;
  text-align: center;
  @media (max-width: 1200px) {
    font-size: 16px;
  }
`
